import { FunctionComponent } from "react";
import { Brand, Organization, PremiumService, Service } from "@App/types";
import { ServiceIsVehicleReturn } from "@App/utils/conditionals/services";
import { useTranslation } from "react-i18next";
import {
  OrganizationHasSelectableBevSupport,
  OrganizationIsAyvensAndServiceIsAppointment,
  ServiceShouldDisplayBevOnCurrentList,
} from "@App/utils/conditionals/combinations";
import { OrganizationIsAyvens } from "@App/utils/conditionals/organization";
import { useSelector } from "react-redux";
import { State } from "@App/state";
import { getServiceNameLabel } from "@App/utils/getServiceNameLabel";

type BookingHeadlineProps = {
  service: Service;
  organization: Organization;
  premiumServices: PremiumService[] | null;
  brand?: Brand;
};

export const BookingHeadline: FunctionComponent<BookingHeadlineProps> = (
  props: BookingHeadlineProps,
) => {
  const { t } = useTranslation(); // i18next

  const bevSupport = useSelector((state: State) => state.filters.bevSupport);
  const serviceName = getServiceNameLabel(organization, props.service, props.premiumServices);

  return (
    <div>
      <div className="text-3xl font-serif mb-1">
        {props.service && ServiceIsVehicleReturn(props.service)
          ? t("booking.vehicleReturn.headline")
          : t("booking.headline")}
      </div>
      {props.service && !OrganizationIsAyvens(props.organization) && (
        <div>
          <span>{t("booking.subheadline", { service: serviceName })}</span>
          {props.brand && (
            <p>
              <span>{t("filters.brand")}</span>
              <span>{props.brand?.name}</span>
            </p>
          )}
          {OrganizationHasSelectableBevSupport(props.organization) &&
            ServiceShouldDisplayBevOnCurrentList(props.service, props.organization) && (
              <p>
                <span>{t("filters.engineType")}</span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: bevSupport ? t("Elektro-/Hybridmotor") : t("Verbrennungsmotor"),
                  }}
                />
              </p>
            )}
        </div>
      )}
      {OrganizationIsAyvensAndServiceIsAppointment(props.organization, props.service) && (
        <span className={"text-sm"}>{t("booking.appointment-hint")}</span>
      )}
    </div>
  );
};
